import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=32e1ec21&"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QBreadcrumbsEl,QChip,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QForm,QSelect,QInput,QIcon,QPopupProxy,QDate,QField,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QBreadcrumbsEl,QChip,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QForm,QSelect,QInput,QIcon,QPopupProxy,QDate,QField})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
